import React, { useEffect, useState } from "react";
import { fabric } from 'fabric';
import style from './RightClickMenu.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { copySelectedDrawing, pasteSelectedDrawing, saveDrawing, showTableModal, enableCropOption } from "../../actions/wizard";

const RightClickMenu = ({ top, left }) => {
  const dispatch = useDispatch();
  const [enableCropBtn, setEnableCropBtn] = useState(false);
  const [enableEditBtn, setEnableEditBtn] = useState(false);
  const [enableGroupBtn, setEnableGroupBtn] = useState(false);
  const [enableUnGroupBtn, setEnableUnGroupBtn] = useState(false);
  const fabricInstance = useSelector((state: any) => state.wizard.fabricInstance);
  const selectedObjects = useSelector((state: any) => state.wizard.selectedObjects);

  // Enable group and un-group button based the element selection
  useEffect(() => {
    const activeObject = fabricInstance?.getActiveObject();
    const activeObjects = fabricInstance?.getActiveObjects();
    if (activeObject && activeObject?.type === 'group') {
      setEnableUnGroupBtn(activeObject);
    }

    if (activeObjects?.length > 1) {
      setEnableGroupBtn(activeObjects);
    }

    if(activeObject?.tableCode?.length) {
      setEnableEditBtn(activeObject?.tableCode)
    }

    if(activeObject?.type === 'image') {
      setEnableCropBtn(true)
    }

  }, [selectedObjects])

  // Function to delete the element
  const deleteSelectedElement = () => {
    const canvas = fabricInstance;
    selectedObjects?.map((e) => {
      fabricInstance.remove(e.group || e);
      fabricInstance.renderAll();
    })


    // Updating data in the API
    dispatch(saveDrawing(''))
  }

  // Function to lock the element
  const lockElement = () => {
    selectedObjects?.map((e) => {
      const obj = {
        selectable:false,
        editable:false,
        evented:false,
        hasControls:false,
        lockMovementX:true,
        lockMovementY:true
      }
      e?.group ? e.group.set(obj) : e.set(obj);
    })
    fabricInstance.renderAll();
    dispatch(saveDrawing(''))
  }

    // Function to Unlock the element
    const unlockElement = () => {
      selectedObjects?.map((e) => {
        const obj = {
          selectable:true,
          hasControls:true,
          editable:true,
          evented:true,
          lockMovementX:false,
          lockMovementY:false
        }
        e?.group ? e.group.set(obj) : e.set(obj);
      })
      fabricInstance.renderAll();
      dispatch(saveDrawing(''))
    }

  // Function to bring to back or front the element
  const bringToFrontAndBack = (type: any) => {
    selectedObjects?.map((e) => {

      // If selection is group
      if (e?.group) {
        type === 'back' ? e?.group.sendToBack() : e?.group.bringToFront();
        e?.group.set("dirty", true);
      } else {
        type === 'back' ? e?.sendToBack() : e.bringToFront();
        e.set("dirty", true);
      }
      fabricInstance.renderAll();
      dispatch(saveDrawing(''))
    })
  }

  // Function to hide the element
  const hideElement = () => {
    selectedObjects?.map((e) => {

      // If selection is group
      if (e?.group) {
        e?.group.set('visible', false);
      } else {
        e.set('visible', false);
      }
      fabricInstance.renderAll();
      dispatch(saveDrawing(''))
    })
  }

  // Function to un-group the elements
  const unGroupElement = () => {
    const object: any = enableUnGroupBtn
    const items = object?._objects;
    object._restoreObjectsState();
    fabricInstance.remove(object);
    items.forEach(item => {
      fabricInstance.add(item);
    });
    fabricInstance.renderAll();
    dispatch(saveDrawing(''))
  }

  // Function to group the elements
  const groupElements = () => {
    const activeObjects = fabricInstance.getActiveObjects();
    if (activeObjects.length > 1) {

      // Clone each active object
      const boundingRect = fabricInstance.getActiveObject().getBoundingRect();
      const clonedObjectsPromises = activeObjects.map(obj => {
        return new Promise(resolve => {
          obj.clone(clonedObj => {

            // Adjust the cloned object's position
            clonedObj.set({
              left: obj.left,
              top: obj.top,
              angle: obj.angle,
              scaleX: obj.scaleX,
              scaleY: obj.scaleY
            });
            resolve(clonedObj);
          });
        });
      });

      Promise.all(clonedObjectsPromises).then(clonedObjects => {
        // Remove original objects from fabricInstance
        fabricInstance.remove(...activeObjects);

        // Create a group with the cloned objects
        const group = new fabric.Group(clonedObjects, {
          left: boundingRect.left,
          top: boundingRect.top,
        });

        // Add the group to the fabricInstance
        fabricInstance.add(group);

        // Deselect the original objects and select the group
        fabricInstance.discardActiveObject();
        fabricInstance.setActiveObject(group);
        fabricInstance.renderAll();
      });
    }
    dispatch(saveDrawing(''))
  }
  
  return (
    <section className={style.rightClick_container} style={{ top: top, left: left }}>
      <div>
        <p onClick={() => dispatch(copySelectedDrawing())}>Copy</p>
        <p onClick={() => dispatch(pasteSelectedDrawing())}>Paste</p>
        <hr />
        <p onClick={() => bringToFrontAndBack('')}>Bring to front</p>
        <p onClick={() => bringToFrontAndBack('back')}>Sent to back</p>
        <hr />
        <p onClick={() => enableUnGroupBtn ? unGroupElement() : ''} className={!enableUnGroupBtn ? style.disabled_btn : ''}>Ungroup</p>
        <p onClick={() => enableGroupBtn ? groupElements() : ''} className={!enableGroupBtn ? style.disabled_btn : ''}>Group</p>
        <p onClick={() => enableCropBtn ? dispatch(enableCropOption(true)) : ''} className={!enableCropBtn ? style.disabled_btn : ''}>Crop</p>
        {enableEditBtn ? <p onClick={() => enableEditBtn ? dispatch(showTableModal(enableEditBtn)) : ''} className={!enableEditBtn ? style.disabled_btn : ''}>Edit Table</p> : ''}
        <hr />
        <p onClick={() => hideElement()}>Hide</p>
        <p onClick={() => lockElement()}>Lock</p>
        {/* <p onClick={() => unlockElement()}>Unlock</p> */}
        <hr />
        <p onClick={() => deleteSelectedElement()}>Delete</p>
      </div>
    </section>
  )
}

export default RightClickMenu;